/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineAvailableTagBatchRequest extends models.BatchRequest {
    getFixupPrototypeFunction() { return TagBaselineAvailableTagBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineAvailableTagBatchRequest>): TagBaselineAvailableTagBatchRequest {
        let obj = Object.assign(new TagBaselineAvailableTagBatchRequest(), model);
        TagBaselineAvailableTagBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineAvailableTagBatchRequest>): TagBaselineAvailableTagBatchRequest {
        if (!model) return null;
        return TagBaselineAvailableTagBatchRequest.newInstance(<TagBaselineAvailableTagBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineAvailableTagBatchRequest) {
        if (!obj) return;

        models.TagBaselineAvailableTagBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineAvailableTagBatchRequest): boolean {
        if (models.BatchRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagBaselineAvailableTagBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.AccountFilters.fixupPrototype(this.filters);
        }
    }

    /**
     * Account filters for the tags
     */
    filters: models.AccountFilters;

}
